module.exports = "<input type=\"checkbox\" [(ngModel)]=\"field.value\" (change)=\"fieldUpdated.emit(field)\" >"


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/thought-module/field/checkbox/checkbox.component.html
// module id = ../../../../../src/app/thought-module/field/checkbox/checkbox.component.html
// module chunks = main